import React from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { Reveal, MaskedLinesInView } from "./Motion";

const Stars = () => (
  <div className="flex gap-1 mb-6" aria-label="5 star rating">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-gold text-gold" />
    ))}
  </div>
);

const Testimonials = () => {
  return (
    <section id="reviews" data-testid="testimonials-section" className="relative py-24 md:py-32 lg:py-40 bg-ink-surface/30 border-y border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase text-gold mb-6">{TESTIMONIALS.overline}</p>
        </Reveal>
        <h2 className="font-serif tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl max-w-3xl mb-16 md:mb-24">
          <MaskedLinesInView lines={[TESTIMONIALS.heading]} className="text-white" />
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.items.map((t, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="glass rounded-3xl p-8 md:p-10 h-full flex flex-col justify-between hover:border-gold/20 transition-colors duration-500"
              >
                <div>
                  <Quote className="w-8 h-8 text-gold/40 mb-6" />
                  <Stars />
                  <blockquote className="font-serif text-2xl md:text-[1.7rem] leading-snug text-white tracking-tight">
                    “{t.quote}”
                  </blockquote>
                </div>
                <figcaption className="mt-8 pt-6 border-t border-white/10">
                  <span className="block text-sm font-medium text-white">{t.name}</span>
                  <span className="block text-xs tracking-[0.2em] uppercase text-gold mt-1">{t.place}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
